// RefMap implements a Map that supports having references as keys
// Mostly mirrors Map() API

// There is no native way to get a hash from an object, so this implementation
// is essentially a pair of arrays. For performance an additional Set is used.
// If needed a HashMap could be implemented for the cases where the keys
// added are primitives.

// Alternative implementation would be to research community
// solutions for creating hash from object.
export default class RefMap {
  _keysSet = new Set();
  _keys = [];
  _values = [];

  has = key => {
    return this._keysSet.has(key);
  };

  set = (key, value) => {
    if (this._keysSet.has(key)) {
      this._values[this._keys.indexOf(key)] = value;
    } else {
      this._keysSet.add(key);
      this._keys.push(key);
      this._values.push(value);
    }
  };

  get = key => {
    if (!this._keysSet.has(key)) return undefined;
    return this._values[this._keys.indexOf(key)];
  };

  delete = key => {
    if (this._keysSet.has(key)) {
      this._keysSet.delete(key);
      const index = this._keys.indexOf(key);
      this._keys.splice(index, 1);
      this._values.splice(index, 1);
      return true;
    }
    return false;
  };

  keys = () => {
    return [...this._keys];
  };

  values = () => {
    return [...this._values];
  };

  entries = () => {
    return this._keys.map((key, index) => [key, this._values[index]]);
  };

  get size() {
    return this._keys.length;
  }

  forEach = (callback, thisArg) => {
    // eslint-disable-next-line no-param-reassign
    if (thisArg) callback = callback.bind(thisArg);
    for (let i = 0; i < this.length; i += 1) {
      callback(this._values[i], this._keys[i], this);
    }
  };

  clear = () => {
    this._keysSet.clear();
    this._keys = [];
    this._values = [];
  };
}
